import React,{useState,useEffect} from 'react';
import {Api} from '../component/api';
import { Link,useNavigate } from 'react-router-dom';
import DefaultProductImage from '../img/product/default-home_default.jpg';

const Search = ({ isOpen, toggleSearch }) => {
  const [data, setData] = useState({
    products:[]});
  const [SearchString, setSearchString] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); 

  async function fetchData(SearchString,nextPage=0) {
    if(!SearchString)
    {
        return;
    }
    setLoading(true);
    try {
        const response = await Api("productSearch",{s: SearchString},'GET',true);
        if(response.success==true){
            setData(response.psdata);
            //setData(response.psdata);
        }
    } catch (error) {
        console.error("API Error:", error);
    } 
    finally {
        setLoading(false); // پایان بارگذاری
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      navigate(`/search?s=${encodeURIComponent(SearchString)}`);
      toggleSearch();
    }
  };
  useEffect(() => {
      fetchData(SearchString);
  }, [SearchString]);

  useEffect(() => {
    if(isOpen==false)
    {
      setSearchString("");
    }
    if (isOpen) {
      const el = document.querySelector(".search-input");
      el?.focus();
    }
  }, [isOpen]);
  
    return (
      <>
      {isOpen && (<div className="cart-backdrop" onClick={toggleSearch}></div>)}
      <div className={`search-container ${isOpen ? 'open' : ''}`}>
        <div className="search-header d-flex justify-content-between align-items-center">
            <input 
              className='search-input' 
              type='text' 
              placeholder='جستجو محصولات...' 
              onChange={(e)=>setSearchString(e.target.value)}
              onKeyDown={handleKeyDown}
              value={SearchString}
            />
          <button className="btn-close" onClick={toggleSearch}></button>
        </div>
       
        {SearchString && (
        <div className='search-result container py-3' >
        {!loading? (
          <div style={{ maxHeight: "300px", overflowY: "auto" }} className="border rounded">
          <ul className="list-group list-group-flush">
          {data.products.map((Product) => (
            <li  key={Product.id_product}
                className="list-group-item d-flex align-items-center gap-3">
                  <Link className="text-decoration-none text-dark fw-semibold" to={`/${Product.id_product}-${Product.link_rewrite}.html`}  onClick={() => toggleSearch()}>
                    <img  className="rounded border" src={Product.cover=== null ? DefaultProductImage : Product.cover.url} alt={Product.name} width="50px"/>{Product.name}
                  </Link>
            </li>
          ))}
          </ul>
          </div>
          ):
          (
            <div class="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            </div>
          )
        }
        </div>
        )}
      </div>
      </>
    );
  };
  
  export default Search;